import ReactDOM from 'react-dom';
// These external and handlebars imports logically belong in child modules, but I'm including them here for technical reasons
import '../../external/jquery/jquery-ajaxq-end.js';
import '../../handlebars/templates/teacherSuggestion.tmpl.js';
import '../../handlebars/templates/schoolSuggestion.tmpl.js';

import SearchController from './searchController.js';


// These must be defined in the JSP (initialProjects is optional)
/* global filterCategories extraFilters searchURLString isMapFeatureEnabled initialProjects
isEssentialsListsEnabled isSchoolLevelGivingEnabled isSendLocationSearchToMapEnabled */
/* global geoLocation */ // comes from geolocation.js in general.js
function setupSearchPage() {
    ReactDOM.hydrate(
        <SearchController searchURL={searchURLString}
            filterCategories={filterCategories} extraFilters={extraFilters}
            initialDetectedLocation={geoLocation} isMapFeatureEnabled={isMapFeatureEnabled} initialProjects={initialProjects && JSON.parse(initialProjects)}
            isEssentialsListsEnabled={isEssentialsListsEnabled}
            isSchoolLevelGivingEnabled={isSchoolLevelGivingEnabled}
            isSendLocationSearchToMapEnabled={isSendLocationSearchToMapEnabled}
        />,
        document.getElementById('content'),
    );
}
if (window.generalLoaded) { setupSearchPage(); } else { window.addEventListener('generalLoaded', setupSearchPage); }
